/**
 *
 * @param template the template string to pass eg. `hello {{name}}`
 * @param variables the map containing key and value of variables eg.`{"{{name}}":"{{data.user.first_name}}"}`
 * @returns
 */
function replaceTemplateVariables(
  template: string | null,
  variables: Record<string, string>
) {
  if (!template) return ""
  return template.replace(/{{(.*?)}}/g, match => {
    if (variables[match]) {
      return variables[match]
    }
    return match
  })
}
export default replaceTemplateVariables
